import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useContext } from 'react';
import { prefix } from '../../../tools/settings';
import cx from 'classnames';
import styled, { css } from 'styled-components';
import Chip from '../../Chip';
import { CardContext } from '../Card';
import { jsxs as _jsxs } from "react/jsx-runtime";

var cardPadding = function cardPadding(props) {
  if (typeof props.padding === 'number') {
    return props.padding + 'px';
  } else {
    return props.padding;
  }
};

var StyledStatusChip = styled(Chip).withConfig({
  displayName: "Status__StyledStatusChip",
  componentId: "sc-rn1lye-0"
})(["", ""], function (props) {
  return props.cardVariant === 'list' ? css(["align-self:flex-end;"]) : css(["margin:0;position:absolute;top:", ";right:", ";z-index:1;"], function (props) {
    return props.padding ? cardPadding : 'var(--dentsu-spacing-24)';
  }, function (props) {
    return props.padding ? cardPadding : 'var(--dentsu-spacing-24)';
  });
});
var Status = forwardRef(function (_ref, ref) {
  var _dataFromProps$hasSta, _dataFromProps$status;

  var children = _ref.children,
      dataFromProps = _ref.data,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx(_defineProperty({}, "".concat(prefix, "-card__status"), true));

  var _useContext = useContext(CardContext),
      cardVariant = _useContext.variant;

  return _jsxs(StyledStatusChip, _objectSpread(_objectSpread({
    ref: ref,
    className: className,
    cardVariant: cardVariant,
    variant: "status",
    hasStatusLight: (_dataFromProps$hasSta = dataFromProps === null || dataFromProps === void 0 ? void 0 : dataFromProps.hasStatusLight) !== null && _dataFromProps$hasSta !== void 0 ? _dataFromProps$hasSta : false,
    status: (_dataFromProps$status = dataFromProps === null || dataFromProps === void 0 ? void 0 : dataFromProps.status) !== null && _dataFromProps$status !== void 0 ? _dataFromProps$status : 'neutral'
  }, rest), {}, {
    children: [dataFromProps === null || dataFromProps === void 0 ? void 0 : dataFromProps.label, !dataFromProps && children]
  }));
});
export default Status;